import React, { useCallback, useState, useEffect } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import Filter from "../../components/Filter/Filter";
import "../pages.scss";
import AddBoxIcon from '@mui/icons-material/AddBox';
import Button from '@mui/material/Button';
import {
  fetchAPIData,
  getCompanyId,
  getToken,
  getUser,
  cleanObject,
  generateHiddenColumns,
  copyToClipboard,
  PermissionsCheck,
  hasPermission,
  platformManage,
  platformPermissionOptions,
  createFilterOptions, createSortFieldOptions
} from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from "@mui/material/Tooltip";
import Divider from '@mui/material/Divider';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import { Typography } from "@mui/material";
import axios from 'axios';
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import Ajv from "ajv";
import EventsDialog from "./EventsDialog";
const eventSchema = require("../../json/eventSchema.json").create;
const eventUpdateSchema = require("../../json/eventSchema.json").update;
const ajv = new Ajv({ strict: false });



const Events = () => {
  const { permissions } = usePermissionContext();
  const [apiData, setApiData] = useState({});
  const [rowJsonData, setRowJsonData] = useState({});
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('view');  // default to view mode
  //const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [confirmProps, setConfirmProps] = useState({});
  const [confirmOpen, setConfirmOpen] = useState(false);
  const formId = 'CreateEventDialog';

  const handleClickOpen = () => {

    let rowData = {};
    const JsonData = rowData;

    setRowJsonData(JsonData);

    setMode('create');
    setReadOnly(false);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  const initialSnackbarState = {
    open: false,
    message: '',
    alertTitle: '',
    severity: 'info',
    hideDuration: 1000
  };

  const [notify, setNotify] = useState(
    initialSnackbarState
  );

  const fieldData = [
    'topic', 'cspTenantUrl', 'ackMode', 'monitorInterval', 'concurrency', 'maxPollRecords',
    'maxPollInterval'];

  const hasPlatformManage = hasPermission(permissions, platformManage);

  const sortFieldData = [
    {
      field: 'topic',
      label: 'Topic'
    },
    {
      field: 'cspTenantUrl',
      label: 'CSP Tenant'
    },
    {
      field: 'ackMode',
      label: 'ACK Mode'
    },
    {
      field: 'monitorInterval',
      label: 'Monitor Interval'
    },
    {
      field: 'concurrency',
      label: 'Concurrency'
    },
    {
      field: 'maxPollRecords',
      label: 'Max Poll Records'
    },
    {
      field: 'maxPollInterval',
      label: 'Max Poll Interval in MS'
    }
  ];

  const totalLabel = "Matching Events";

  const deleteData = useCallback((rowData) => () => {
    // console.log("delete icon clicked", rowData);

    let eventId = rowData.topic;

    let title = "Delete Event";

    let msg =
      <>
        <Typography variant="body1" paragraph="true">
          Are you sure you want to delete this event ?
        </Typography>
        <Typography variant="body1" paragraph="true">
          {`[${eventId}]`}
        </Typography>
      </>

    let confirmProps = {
      title,
      msg,
      confirmCallback: () => deleteEvent(eventId)
    };

    setConfirmProps(confirmProps);

    setConfirmOpen(true);

  }, []);

  const deleteEvent = (eventId) => {

    let deleteUrl = `/api/events/${eventId}/configs`;


    axios({
      method: "delete", url: deleteUrl,
      headers: { "insightUserId": getUser(), "Authorization": getToken() }
    })
      .then(response => {

        let message = `Deleted event [${eventId}]`;

        setNotify({
          isOpen: true,
          message: message,
          severity: 'info'
        });

        // do we need to reload??
        // console.log("current data: ", apiData);
        setApiData([]);
        setReload(true);

      }).catch(error => {
        console.log('error in delete event api call:', error);

        let message = `Failed to delete core event [${eventId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });
      });
  };


  const getActionButtons = (params) => {
    let actionButtons = [];

    let editButton = <GridActionsCellItem icon={
      <Tooltip title="Edit" arrow placement="right">
        <EditIcon />
      </Tooltip>}
      label='View/Edit'
      onClick={viewEditData(params.row)}
    />;

    hasPlatformManage && actionButtons.push(editButton);

    //delete button icon
    let deleteButton = <GridActionsCellItem icon={
      <Tooltip title="Delete" arrow placement="right">
        <DeleteIcon />
      </Tooltip>}
      label='Delete'
      onClick={deleteData(params.row)}
    />;

    hasPlatformManage && actionButtons.push(deleteButton);

    return actionButtons;

  };

  const columns = [
    // {
    //   field: 'id',
    //   type: 'number',
    //   headerName: 'ID',
    //   hide: true,
    //   minWidth: 25,
    //   flex: 1,
    //   headerAlign: 'left',
    //   align: 'left',
    // },
    {
      field: 'actions',
      type: 'actions',
      hideable:false,
      headerName: 'Actions',
      minWidth: 130,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      getActions: (params) => getActionButtons(params)
    },
    {
      field: 'topic',
      hideable:false,
      headerName: 'Topic',
      minWidth: 425,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <div className="clipboardContent">
                <div style={{ width: '355px' }}>
                  {params.value}
                </div>
                <Tooltip title="Copy to clipboard" arrow placement="right">
                  <IconButton aria-label="copy topic" onClick={(event) => copyToClipboard(event, params.row.topic)}>
                    <CopyIcon sx={{ fontSize: 'small' }} />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </>
        )
      }
    },
    {
      field: 'cspTenantUrl',
      hideable:false,
      headerName: 'CSP Tenant',
      minWidth: 425,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <div className="clipboardContent">
                <div style={{ width: '350px' }}>
                  <a style={{ cursor: 'pointer' }} href={params.value} target="_blank" rel="noreferrer">{params.value}</a>
                </div>
                <Tooltip title="Copy to clipboard" arrow placement="right">
                  <IconButton aria-label="copy CSP Tenant URL" onClick={(event) => copyToClipboard(event, params.row.cspTenantUrl)}>
                    <CopyIcon sx={{ fontSize: 'small' }} />
                  </IconButton>
                </Tooltip>


              </div>
            )}
          </>
        );
      }
    },
    {
      field: 'ackMode',
      hideable:false,
      headerName: 'ACK Mode',
      type: 'string',
      hide: false,
      minWidth: 100,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      field: 'monitorInterval',
      hideable:false,
      headerName: 'Monitor Interval',
      type: 'number',
      minWidth: 200,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      field: 'concurrency',
      hideable:false,
      headerName: 'Concurrency',
      type: 'number',
      hide: false,
      renderCell: renderCellExpand,
      minWidth: 150,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'maxPollRecords',
      hideable:false,
      headerName: 'Max Poll Records',
      type: 'number',
      hide: false,
      minWidth: 150,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      field: 'maxPollInterval',
      hideable:false,
      headerName: 'Max Poll Interval in MS',
      type: 'number',
      hide: false,
      minWidth: 160,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand
    }
  ];

  const getColumns = () => {
    return (hasPlatformManage && columns) || columns.filter(obj => { return obj.field !== "actions"});
  };
  
  const toggleColumnPinning = () => {
    return (hasPlatformManage && 'columnPinning') || '';
  };

  const viewEditData = useCallback((rowData) => () => {
    // console.log("view/edit icon clicked", rowData);

    // remove the id from table data as table data only not part of json stored
    const {
      id,
      ...JsonData
    } = rowData;

    setRowJsonData(JsonData);
    setMode('edit');
    setReadOnly(false);
    setOpen(true);
  }, []);

  const viewRowData = (param, event) => {

    // remove the id from table data as table data only not part of json stored
    const {
      id,
      ...JsonData
    } = param.row;

    setRowJsonData(JsonData);
    setMode('view');
    setReadOnly(true);
    setOpen(true);
  };

  const [events, setEvents] = usePersistentStorage("events", []);

  useEffect(() => {
    // check if localstorge had data for the current tab
    setApiData(events);
  }, []);


  const fetchData = async (apiURL2, qparams) => {
    setIsloading(true);
    await fetchAPIData(apiURL2, qparams)
      .then((data) => {
        setApiData(data);
        setEvents(data);
        setReload(false);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);

        let message = `Failed to load events data \n\n ${err.response.statusText} : ${err.response.data.message}`;
        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });

        setApiData([]);
        setReload(false);
        setIsloading(false);
      });
  }

  const handleJsonChange = (formData) => {
    // console.log("Dialog JSON has changed", formData);

    setRowJsonData(formData);
  };

  const handleFormChange = (data) => {
    setRowJsonData(data.formData);
  }

  //----


  const validateSchema = (eventSchema, data) => {
    // console.log('got json schema', eventSchema);
    const validate = ajv.compile(eventSchema);
    const valid = validate(data);
    if (!valid) {
      console.log(validate.errors);
      return false;
    }
    return true;
  }

  const saveEventsData = (formData) => {

    // console.log('called save events:', formData);
    // console.log('current mode:', mode);

    // react json form generates an empty object when nothing set.
    // Remove empty objects that could cause issues with backend API validation 
    let cleanedObj = cleanObject(formData);

    if (mode === 'edit') {
      if (validateSchema(eventUpdateSchema, cleanedObj)) {
        //call save API
        //console.log('validated successfully..');
        updateEvents(cleanedObj);
      }
    }
    if (mode === 'create') {
      if (validateSchema(eventSchema, cleanedObj)) {
        //call save API
        // console.log('validated successfully..');
        createEvents(cleanedObj);
      }
    }
  }

  const createEvents = (data) => {
    try {
      // console.log('inside events create api..');
      axios({ method: "post", url: '/api/events/configs', data: data, headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() } })
        .then(response => {
          if (response.status === 200) {
            let message = `Event config created successfully`;

            setNotify({
              isOpen: true,
              message: message,
              severity: 'info'
            });
            // console.log('got response from events create:', response);
            setReload(true);
            setOpen(false);
          }

        }).catch(error => {
          let message = `Event config create failed: ${error.response.data.message}`;

          setNotify({
            isOpen: true,
            alertTitle: 'Request failed',
            message: message,
            severity: 'error'
          });
          console.log('error in create events api call:', error.response.data.message);
        });
    }
    catch (e) {
      console.log(e);
      let message = `Event config create failed `;

      setNotify({
        isOpen: true,
        alertTitle: 'Request failed',
        message: message,
        severity: 'error'
      });
    }
  }


  const updateEvents = (data) => {
    try {
      // console.log('inside events update api..');
      axios({ method: "put", url: '/api/events/' + data.topic + '/configs', data: data, headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() } })
        .then(response => {
          if (response.status === 200) {
            let message = `Event config updated successfully`;

            setNotify({
              isOpen: true,
              message: message,
              severity: 'info'
            });
            // console.log('got response from events update:', response);
            setReload(true);
            setOpen(false);
          }

        }).catch(error => {
          let message = `Event config update failed: ${error.response.data.message}`;

          setNotify({
            isOpen: true,
            alertTitle: 'Request failed',
            message: message,
            severity: 'error'
          });
          console.log('error in update events api call:', error.response.data.message);
        });
    }
    catch (e) {
      console.log(e);
      let message = `Event config update failed `;

      setNotify({
        isOpen: true,
        alertTitle: 'Request failed',
        message: message,
        severity: 'error'
      });
    }
  }
  //----
  return (
    <>

      <AlertSnackbar
        notify={notify}
        setNotify={setNotify} />

      <div id="headerContainer" className="headerContainer">
        <div id="companyHeader" className="eventsHeaderContainer">
          <div id="content-left" className="content-left">
            <div id="eventPageTitle" className="eventPageTitle">Events</div>
            <PermissionsCheck
                            RenderError={() => <></>}
                            scopes={platformManage}>
            <div id="subhead" className="subhead">
              <Button variant="text" endIcon={<AddBoxIcon color="primary" />} className="subheadText" onClick={handleClickOpen}>CREATE EVENT</Button>
            </div>
            </PermissionsCheck>
          </div>
        </div>
      </div>

      <div id="eventsFilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
        <Filter permission={platformPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL='/api/events/configs?' fetchData={fetchData} useCompanyId={false} reload={reload} totalLabel={totalLabel} tabName={'eventsTab'}/>
      </div>


      <Divider />

      <div id="eventsTableContainer" className={toggleColumnPinning()} >
        <div >
          <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading}/>
        </div>
      </div>


      <ActionDialog
        open={open}
        mode={mode}
        onClose={handleClose}
        onSave={() => handleSave(formId, rowJsonData, saveEventsData)}
        title="Event Information"
        propertiesTabContent={
          <EventsDialog
            formId={formId}
            eventSchema={mode === 'edit' ? eventUpdateSchema : eventSchema}
            saveEventsData={saveEventsData}
            formData={rowJsonData} handleFormChange={handleFormChange}
            readOnly={readOnly}
          />
        }
        jsonDataName="events"
        JSONTabContent={rowJsonData}
        handleJsonChange={handleJsonChange}
      />


      <ConfirmDialog
        title={confirmProps.title}
        open={confirmOpen}
        onClose={handleConfirmClose}
        setOpen={setConfirmOpen}
        cancelButtonText={confirmProps.cancelButtonText}
        confirmButtonText={confirmProps.confirmButtonText}
        onConfirm={confirmProps.confirmCallback}
      >
        {confirmProps.msg}
      </ConfirmDialog>

    </>
  );

}

export default Events;